import ScrollBooster from 'scrollbooster';

export default function () {
  const advance = document.querySelector('.advance');
  const advanceClose = document.querySelector('.advance-close');
  advanceClose.addEventListener('click', function() {
    advance.classList.remove('active');
  }, false);

}
